/**
 * Telegram Mini App launch params helpers.
 * iOS/ngrok often puts params only in location.hash; vue-router navigations can drop the hash
 * before @telegram-apps/sdk reads it → LaunchParamsRetrieveError and stuck isRestoring.
 */

const STORAGE_KEY = 'tapps/launchParams'

function toQueryLike(href) {
  if (!href || typeof href !== 'string') {
    return ''
  }
  return href.replace(/^[^?#]*[?#]/, '').replace(/[?#]/g, '&')
}

export function getTelegramLaunchQueryRaw() {
  const sources = [
    typeof window !== 'undefined' ? window.location.href : '',
    typeof performance !== 'undefined'
      ? performance.getEntriesByType?.('navigation')?.[0]?.name
      : '',
  ]

  for (const href of sources) {
    const raw = toQueryLike(href)
    if (raw.includes('tgWebAppData=') || raw.includes('tgWebAppVersion=')) {
      return raw
    }
  }

  try {
    const cached = sessionStorage.getItem(STORAGE_KEY)
    if (cached && (cached.includes('tgWebAppData=') || cached.includes('tgWebAppVersion='))) {
      return cached
    }
  } catch {
    // ignore
  }

  return ''
}

/** Persist launch query ASAP so later /welcome navigation cannot wipe it. */
export function persistTelegramLaunchParams() {
  const raw = getTelegramLaunchQueryRaw()
  if (!raw) {
    return null
  }

  try {
    sessionStorage.setItem(STORAGE_KEY, raw)
  } catch {
    // ignore
  }

  return raw
}

export function extractInitDataRaw(queryLike = getTelegramLaunchQueryRaw()) {
  if (!queryLike) {
    return null
  }

  const params = new URLSearchParams(queryLike.replace(/^[#?]/, '').replace(/[?#]/g, '&'))
  const initData = params.get('tgWebAppData')
  return initData || null
}

export function buildLaunchParamsFallback(queryLike = getTelegramLaunchQueryRaw()) {
  const initDataRaw = extractInitDataRaw(queryLike)
  if (!initDataRaw) {
    return null
  }

  const params = new URLSearchParams(queryLike.replace(/^[#?]/, '').replace(/[?#]/g, '&'))

  return {
    initDataRaw,
    platform: params.get('tgWebAppPlatform') || undefined,
    version: params.get('tgWebAppVersion') || undefined,
  }
}
